module.exports = __webpack_public_path__ + "dice.mp3";